import React from "react";
import ReactDOM from "react-dom";
import "./Assets/css/styles.css";
import "./Assets/css/fonts.css";
import "./index.css";
import App from "./App";

import { Auth0Provider } from "@auth0/auth0-react";
import { Environments } from "./Environments/Environments";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

import { LanguageProvider } from "./Components/languageContext/LanguageContext";
import "./Lang/config";
import { ErrorBoundary } from "./Layouts/ErrorBoundary/ErrorBoundary";

ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider
      //domain="dev-3563fiustl3qmxma.us.auth0.com"
      domain="nanofreeze.us.auth0.com"
      //clientId="YE4c5X8qScUFLbRHpHo6aLJAzLiBLFh5"
      clientId="5fIbMSc2j6nkJGHbPYfytWLOMKi906gN"
      authorizeTimeoutInSeconds={50}
      redirectUri={Environments.ibisa20}
      //audience="https://dev-3563fiustl3qmxma.us.auth0.com/api/v2/"
      audience="https://nanofreeze.us.auth0.com/api/v2/"
      scope="openid profile email"
    >
      <ErrorBoundary>
        <LanguageProvider>
          <App />
        </LanguageProvider>
      </ErrorBoundary>
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById("root"),
);

// PWA
serviceWorkerRegistration.register();
reportWebVitals();